//export const API_SERVER_URL = process.env.REACT_APP_API_URL
let API_SERVER_URL;

if (!process.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL === "") {
  API_SERVER_URL = `${window.location.hostname}/api/v1/`;

  if (API_SERVER_URL.includes("localhost")) {
    API_SERVER_URL = `http://${API_SERVER_URL}`;
  } else {
    API_SERVER_URL = `https://${API_SERVER_URL}`;
  }
} else {
  API_SERVER_URL = process.env.REACT_APP_API_URL;
}

export { API_SERVER_URL };


//alert(API_SERVER_URL)
//export const API_SERVER_URL = "http://127.0.0.1:5000/"
//export const API_SERVER_URL = process.env.REACT_APP_API_URL
// export const API_SERVER_URL = "http://20.15.166.198:5000/"
//export const API_SERVER_URL = "http://20.15.166.198:5000/"